
import { Component, OnInit, ViewChild, OnDestroy, Output, Input, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { ModalService, ToastService } from '../../blocks';
import { StockParms, UserSessionService, StockParmsSpesial } from '../../shared';
import { ExaminationSupplyService } from './examination-supply.service';
import { HrAlertApprovalCycleTransEmpComponent } from '../../personnel-setup/hr-alert-approval-cycle-trans-emp/hr-alert-approval-cycle-trans-emp.component';
@Component({
  selector: 'sanabel-examinationSupply-list',
  templateUrl: './examination-supply-list.component.html'
})
export class ExaminationSupplyListComponent implements OnInit {

  examinationSupply = [];
  @Output() clicked: EventEmitter<any>;
  @Output() Print: EventEmitter<any>;
  @Input() examminationFlag: any;
  @Input() ExaminationType: number;
  totalRecords: number = 0;
  appCodes = [];
  linkCode: number;
  mode: number;
  dynamicComponent: any;
  dynamicPrintComponent: any;
  @ViewChild('content') content: any;//===============================================/////

  toggleApprovedList: boolean;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  IteminexaminationSupply = [];
  _StockParms = <StockParmsSpesial>{};////////////-------------------------------------
  //toggleFillter: boolean = true;
  ExamminationSupplyObj: any;
  constructor(
    private _ExaminationSupplyService: ExaminationSupplyService,
    private _UserSessionService: UserSessionService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _toastService: ToastService,
    public translate: TranslateService,
    private _modalService: ModalService) {
    this.clicked = new EventEmitter<any>();
    this.Print = new EventEmitter<any>();
    _route.params.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(val => {
        if (this._UserSessionService.getSessionKey<any>('link')) {
          let link = this._UserSessionService.getSessionKey('link');
          if (link) {
            let linkMode = link['mode'];
            this.linkCode = link['code']
            this._UserSessionService.setSessionKey('RouterParms', linkMode);
          }

        }
      })
  }

  ngOnInit() {
    this._UserSessionService.subscribeToKey$('RouterParms')
      .subscribe((keys: any) => {
        if (keys.value) {
          if (this._UserSessionService.getSessionKey<any>('link')) {
            let link = this._UserSessionService.getSessionKey('link');
            this.linkCode = link['code']
            this.examinationSupply = [];
          }
        }
      });
    this._UserSessionService.subscribeToKey$('link')
      .subscribe((keys: any) => {
        if (keys.value) {

          this.examinationSupply = [];

        }
      });
    this._UserSessionService.subscribeToKey$('ExaminationType')
      .subscribe((keys: any) => {
        if (keys.value) {
          this.ExaminationType = keys.value
          this.getexaminationSupplys(this._StockParms, false);
          this.examinationSupply = [];
        }
      });



  }


  onSearchClick(_searchOnj: any) {
    this._StockParms = _searchOnj;
    this.getexaminationSupplys(this._StockParms, false);
  }

  getexaminationSupplys(_StockParms: any, paginate: boolean) {
    this.examinationSupply = [];
    this._StockParms = <StockParmsSpesial>{};
    let temp = [];
    var prem: StockParmsSpesial = {
      itemType: this.ExaminationType,
      supplierCode: _StockParms.supplierCode,
      fromDate: _StockParms.ngbFromDateStr,
      toDate: _StockParms.ngbToDate,
      store: _StockParms.store,
      serial: _StockParms.fastSearchData,
      status: _StockParms.status,
      pageSize: _StockParms.rows,
      offset: _StockParms.first
    }
    let link = this._UserSessionService.getSessionKey('link');
    let mode = this._UserSessionService.getSessionKey('link')['mode'];
    this.mode = mode
    if (mode == 3) { // استلام وفحص ااصول
      prem.itemType = 3;
    }
    if (mode == 2) { //مستلزمات استلام وفحص 
      prem.itemType = 2;

    }
    if (mode == 1) { // ادويه
      prem.itemType = 1;
    }



    // if (link['code'] == 6578 || link['code'] == 6579) { // استلام وفحص ااصول
    //   prem.itemType = 3;
    // }
    // if (link && link['code'] == 5301) { //مستلزمات استلام وفحص 
    //   prem.itemType = 2;

    // }
    // if (link && link['code'] == 5408) { // ادويه
    //   prem.itemType = 1;
    // }

    // if (link['code'] == 5204 || link['code'] == 5216) {
    //   prem.itemType = this.ExaminationType;
    // }
    temp.push(prem);
    this._ExaminationSupplyService.getExaminationSupply(temp)
      .subscribe(
        examinationSupply => {
          if (examinationSupply && examinationSupply.data) {
            this.examinationSupply = examinationSupply.data;
            this.totalRecords = this.examinationSupply.length > 0 ? this.examinationSupply[0]['rowsCount'] : 0;
          }
        },
        error => console.log(error),
        () => {
          null
        });
  }


  getCSSClasses(_row: any, index?: number) {
    let cssClasses = '';
    if (_row) {
      if (_row.IsExamin == 0) {
        cssClasses = 'table-sucess';
      } else if (_row.IsExamin == 1) {
        cssClasses = 'table-danger';
      }

      return cssClasses;
    }
  }
  onRowIconClick(actionCode: number, examinationSupply: any) {

    if (actionCode == 403)
      this.delete(examinationSupply);
    if (actionCode == 404)
      this.clicked.emit(examinationSupply)
    if (actionCode == 1013)///////// print
    {
      this.Print.emit(examinationSupply);
    }

    if (actionCode == 7043) {
      this.showEmpApproval(examinationSupply);
    }
    //توقيع المستلم 
    if (actionCode == 7054) {
      this.updateExaminationUserSignature(examinationSupply);
    }

  }

  updateExaminationUserSignature(examinationSupply: any) {
    this._modalService.activeDelMes('تأكيد توقيع المستلم', 'Confirm User Signature').then(responseOK => {
      if (responseOK) {
        this._ExaminationSupplyService.updateExaminationUserSignature(examinationSupply)
          .subscribe(c => {
          }, error => console.log(error),
            () => this.getexaminationSupplys(this._StockParms, false));
      }
    });
  }





  showEmpApproval(req) {
    console.log('req', req)
    this.dynamicComponent = HrAlertApprovalCycleTransEmpComponent;
    this._UserSessionService.setSessionKey('AlertApprovalCycleTransEmpSession', { alertSerial: req.serial, requestType: 'EXAMINATION_ORDER' })
    this.content.openModal("HrAlertApprovalCycleTransEmpComponent", "alertSerial", req.serial);
  }

  onpopupClose(e) { }
  getExaminationDetails(event) {
    if (event)
      this.IteminexaminationSupply = [];
    let temp = [];
    var prem: StockParms = {
      serial: event.serial
    }
    temp.push(prem);
    this.ExamminationSupplyObj = event;
    this._UserSessionService.setSessionKey("ExamminationSupplyObj", this.ExamminationSupplyObj)
    this._ExaminationSupplyService.getExaminationSupply(temp)
      .subscribe(
        examinationSupply => {
          if (examinationSupply.data2 && examinationSupply.data2.length > 0) {
            this.IteminexaminationSupply = examinationSupply.data2;
          }
          if (examinationSupply.data3 && examinationSupply.data3.length > 0) {
            this._UserSessionService.setSessionKey("taxNatureValue", examinationSupply.data3[0].taxNature)
          }
        },
        error => console.log(error),
        () => {
          if (this.IteminexaminationSupply.length > 0) {
            this._UserSessionService.setSessionKey('IteminexaminationSupply', this.IteminexaminationSupply)
            this._router.navigate(['/stock/direcradd']);
          }
          else if (this.IteminexaminationSupply.length = 0) {
            this._toastService.activateMsg("UI104");
          }
        }); 
  }

  paginate(_parms: any) {
    let _StockParms = _parms
    this.getexaminationSupplys(_StockParms, false);
  }



  delete(examinationSupply: any) {
    if (examinationSupply.orderStatus != 1) {
      this._toastService.activateMsg("UI78")
      return;
    }
    this._modalService.activeDelMes(examinationSupply.nameAr, examinationSupply.nameEn).then(responseOK => {
      if (responseOK) {
        this._ExaminationSupplyService.deleteStrExaminationSupply(examinationSupply)
          .subscribe(c => {
          }, error => console.log(error),
            () => this.getexaminationSupplys(this._StockParms, false));
      }
    });
  }
}
